/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/main.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@biotope/resource-loader/lib/index.esm.js":
/*!****************************************************************!*\
  !*** ./node_modules/@biotope/resource-loader/lib/index.esm.js ***!
  \****************************************************************/
/*! exports provided: default, ResourceLoader */
/*! ModuleConcatenation bailout: Module uses eval() */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResourceLoader", function() { return ResourceLoader; });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

const EVENTS = {
  RESOURCE_LOADED: 'RESOURCE_LOADED',
  COMPONENT_READY: 'COMPONENT_READY'
};

const getResourceElements = (container = document) => [].slice.call(container.querySelectorAll('[data-resources]'));

const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);

const curry = fn => {
  return (...xs) => {
    if (xs.length === 0) {
      throw Error('EMPTY INVOCATION');
    }

    if (xs.length >= fn.length) {
      return fn(...xs);
    }

    return curry(fn.bind(null, ...xs));
  };
};

const defaultTo = (def, check) => check || def;

var defaultTo$1 = curry(defaultTo);

const prop = (key, obj) => obj[key];

var prop$1 = curry(prop);
const getDataResourceFromElement = pipe(defaultTo$1(document.createElement('div')), prop$1('dataset'), prop$1('resources'), defaultTo$1(''));

const getComponentQueueFromElement = (element = document.createElement('div')) => {
  const dataResources = getDataResourceFromElement(element);
  const definitions = eval(dataResources) || [];
  return definitions.map(d => Object.assign({}, d, {
    element
  }));
};

const unnest = arr => [].concat.apply([], arr);

const getContentDefinitionsFromDOM = (container = document) => {
  const domResources = getResourceElements(container);
  return unnest(domResources.map(getComponentQueueFromElement));
};

const unique = arr => arr.filter((value, index, self) => self.indexOf(value) === index);

const mergeResources = (resources = []) => {
  return resources.reduce((aggregated, current) => {
    if (aggregated.map(r => r.path).indexOf(current.path) !== -1) {
      return aggregated;
    }

    return [...aggregated, Object.assign({}, current, {
      dependencyPaths: unique(unnest(resources.filter(r => r.path === current.path).map(r => r.dependencyPaths || []))),
      elements: unique(unnest(resources.filter(r => r.path === current.path).map(r => r.elements || [])))
    })];
  }, []);
};

const resolveBaseWith = (baseMap, base) => {
  if (!(base.substring(0, 2) === '##')) {
    return base;
  }

  return baseMap[base] || '';
};

var resolveBaseWith$1 = curry(resolveBaseWith);

const isAbsolute = path => new RegExp('^(?:[a-z]+:)?//', 'i').test(path);

const isRootPath = path => path.indexOf('/') === 0 && path.indexOf('//') !== 0;

const getTrailingSlashesRegex = () => /\/?$/;

const getLeadingSlashesRegex = () => /^\/?/;

const replace = (selector, newValue, target) => target.replace(selector, newValue);

var replace$1 = curry(replace);
const ensureTrailingSlash = replace$1(getTrailingSlashesRegex(), '/');
const ensureNoLeadingSlash = replace$1(getLeadingSlashesRegex(), '');

const identity = el => el;

const concat = (t1, t2) => t1 + t2;

var concat$1 = curry(concat);

const always = () => true;

const max = (a, b) => b > a ? b : a;

const _arity = (n, fn) => {
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };

    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };

    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };

    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };

    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };

    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };

    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };

    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };

    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };

    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };

    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };

    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};

const cond = pairs => {
  const arity = pairs.map(pair => pair[0].length).reduce(max, 0);
  return _arity(arity, function () {
    var idx = 0;

    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }

      idx += 1;
    }
  });
};

var cond$1 = curry(cond);

const isHtmlFilePath = path => /^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?\.html([a-zA-Z0-9\-\.\?\!\,\'\/\\\+&amp;%\$#_]*)?$/gm.test(path);

const shift = arr => {
  const clone = [...arr];
  clone.shift();
  return clone;
};

const ensureNoHtmlFile = path => isHtmlFilePath(path) ? shift(path.split('/').reverse()).reverse().join('/') : path;

const defaultToEmptyString = defaultTo$1('');

const ensureAbsolutePath = location => cond$1([[isAbsolute, identity], [isRootPath, pipe(ensureNoLeadingSlash, concat$1(ensureTrailingSlash(location.origin)))], [always, pipe(ensureNoLeadingSlash, concat$1(ensureTrailingSlash(ensureNoHtmlFile(location.href))))]]);

const createEnsureAbsolutePath = location => pipe(defaultToEmptyString, ensureAbsolutePath(location));

const isRelative = path => !isAbsolute(path);

const normalizePath = (path = '', resource, options) => {
  if (resource && options && isRelative(path)) {
    if (resource.base) {
      const resolveBase = resolveBaseWith$1(options.baseMap);
      const ensureAbsolutePath = createEnsureAbsolutePath(window.location);
      return ensureAbsolutePath(ensureTrailingSlash(resolveBase(resource.base)) + path);
    } else if (options.base) {
      const ensureAbsolutePath = createEnsureAbsolutePath(window.location);

      if (isRootPath(path)) {
        return ensureAbsolutePath(path);
      }

      return ensureAbsolutePath(ensureTrailingSlash(options.base) + path);
    }
  }

  return path;
};

const toResources = (options, definition) => {
  if (!definition) {
    return [];
  }

  const pathResources = definition.paths.map(path => ({
    path: normalizePath(path, definition, options),
    dependencyPaths: (definition.dependsOn ? definition.dependsOn : []).map(p => normalizePath(p, definition, options)),
    elements: [definition.element]
  }));
  const dependencyResources = (definition.dependsOn ? definition.dependsOn : []).map(path => ({
    path: normalizePath(path, definition, options),
    dependencyPaths: [],
    elements: [definition.element]
  }));
  return [...pathResources, ...dependencyResources];
};

var toResources$1 = curry(toResources);

const getResourcesFromContainer = (options, container) => {
  const componentDefinitions = getContentDefinitionsFromDOM(container);
  return mergeResources(unnest(componentDefinitions.map(toResources$1(options))));
};

var getResourcesFromContainer$1 = curry(getResourcesFromContainer);

const loadResource = resource => {
  return fetch(resource.path).then(response => {
    const e = new CustomEvent(EVENTS.RESOURCE_LOADED, {
      detail: {
        resource,
        response
      }
    });
    document.dispatchEvent(e);
  });
};

const loadResources = resources => resources.map(loadResource);

const getResourceByPath = (resources, path) => resources.find(r => r.path === path); // ⚠️ TODO: does not check circular dependencies!!!


const checkIfResolvable = (resources = []) => {
  return resources.every(resource => resource.dependencyPaths.every(path => !!getResourceByPath(resources, path)));
};

const getReadyResources = (resourcesToCheck = [], loadedResources = []) => {
  return resourcesToCheck.filter(resource => resource.dependencyPaths.every(path => loadedResources.some(res => res.path === path)));
};

const isCss = options => options.resource.path.indexOf('.css') > -1;

const onCssLoaded = options => {
  const style = document.createElement('link');
  style.rel = 'stylesheet';
  style.href = options.resource.path;
  document.body.append(style);
};

const cssHandler = {
  match: isCss,
  handle: onCssLoaded
};

const isJs = options => options.resource.path.indexOf('.js') > -1;

const onJsLoaded = options => {
  const script = document.createElement('script');
  script.src = options.resource.path;
  script.async = true;
  document.body.append(script);
};

const jsHandler = {
  match: isJs,
  handle: onJsLoaded
};

const isEmpty = test => test.length === 0;

function _Set() {
  /* globals Set */
  this._nativeSet = typeof Set === 'function' ? new Set() : null;
  this._items = {};
} // until we figure out why jsdoc chokes on this
// @param item The item to add to the Set
// @returns {boolean} true if the item did not exist prior, otherwise false
//


_Set.prototype.add = function (item) {
  return !hasOrAdd(item, true, this);
}; //
// @param item The item to check for existence in the Set
// @returns {boolean} true if the item exists in the Set, otherwise false
//


_Set.prototype.has = function (item) {
  return hasOrAdd(item, false, this);
}; //
// Combines the logic for checking whether an item is a member of the set and
// for adding a new item to the set.
//
// @param item       The item to check or add to the Set instance.
// @param shouldAdd  If true, the item will be added to the set if it doesn't
//                   already exist.
// @param set        The set instance to check or add to.
// @return {boolean} true if the item already existed, otherwise false.
//


function hasOrAdd(item, shouldAdd, set) {
  var type = typeof item;

  switch (type) {
    case 'undefined':
      if (set._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type] = true;
        }

        return false;
      }

    case 'object':
      if (item === null) {
        if (!set._items['null']) {
          if (shouldAdd) {
            set._items['null'] = true;
          }

          return false;
        }

        return true;
      }

    /* falls through */

    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);

      if (!(type in set._items)) {
        if (shouldAdd) {
          set._items[type] = [item];
        }

        return false;
      } // scan through all previously applied items


      if (set._items[type].indexOf(item) === -1) {
        if (shouldAdd) {
          set._items[type].push(item);
        }

        return false;
      }

      return true;
  }
}

const difference = (first, second) => {
  const out = [];
  let idx = 0;
  const firstLen = first.length;
  const secondLen = second.length;
  const toFilterOut = new _Set();

  for (let i = 0; i < secondLen; i++) {
    toFilterOut.add(second[i]);
  }

  while (idx < firstLen) {
    if (toFilterOut.add(first[idx])) {
      out[out.length] = first[idx];
    }

    idx += 1;
  }

  return out;
};

var difference$1 = curry(difference);

const remove = (start, deleteCount, arr) => [...arr].splice(start, deleteCount);

var remove$1 = curry(remove);

let ResourceLoader = /*#__PURE__*/function () {
  function ResourceLoader(options) {
    this.options = null;
    this.pendingResources = [];
    this.loadedResources = [];
    this.defaultOptions = {
      readyEvent: 'resourcesReady',
      handler: [cssHandler, jsHandler]
    };
    this.options = Object.assign({
      container: this.defaultContainer
    }, this.defaultOptions, options);
    this.bindEvents();
    this.init(this.options);
  }

  var _proto = ResourceLoader.prototype;

  _proto.init = function init(options) {
    this.prepareQueue(options);
    loadResources(this.pendingResources);
  };

  _proto.prepareQueue = function prepareQueue(options) {
    this.waitingResources = [...getResourcesFromContainer$1(options, options.container)];
    this.waitingResources = this.cleanLoadedFromWaiting();
    checkIfResolvable(this.waitingResources);
    this.pendingResources = [...this.pendingResources, ...getReadyResources(this.waitingResources, this.loadedResources)];
    this.waitingResources = difference$1(this.waitingResources, this.pendingResources);
  };

  _proto.cleanLoadedFromWaiting = function cleanLoadedFromWaiting() {
    return this.waitingResources.filter(resource => !this.loadedResources.some(loaded => loaded.path === resource.path));
  };

  _proto.getStatus = function getStatus() {
    return {
      waiting: this.waitingResources,
      pending: this.pendingResources,
      loaded: this.loadedResources
    };
  };

  _proto.bindEvents = function bindEvents() {
    document.addEventListener(EVENTS.RESOURCE_LOADED, this.onResourceLoaded.bind(this));
    document.addEventListener(this.options.readyEvent, this.onReady.bind(this));
  };

  _proto.onResourceLoaded = function onResourceLoaded(event) {
    const resource = event.detail.resource;
    const handler = this.options.handler.map(handler => [handler.match, handler.handle]);
    cond$1(handler)(event.detail);
    this.loadedResources.push(resource);
    const readyForLoad = getReadyResources(this.waitingResources, this.loadedResources);
    this.pendingResources = [...remove$1(this.pendingResources.indexOf(resource), 1, this.pendingResources), ...readyForLoad];
    this.waitingResources = difference$1(this.waitingResources, this.pendingResources);
    loadResources(readyForLoad);

    if (isEmpty(this.waitingResources) && isEmpty(this.pendingResources)) {
      const event = new CustomEvent(this.options.readyEvent);
      document.dispatchEvent(event);
    }
  };

  _proto.onReady = function onReady() {};

  _proto.update = function update() {
    this.init(this.options);
  };

  _createClass(ResourceLoader, [{
    key: "defaultContainer",
    get: function () {
      return document.querySelector('body');
    }
  }]);

  return ResourceLoader;
}();

/* harmony default export */ __webpack_exports__["default"] = (ResourceLoader);


/***/ }),

/***/ "./src/resources/js/polyfills/array.fill.js":
/*!**************************************************!*\
  !*** ./src/resources/js/polyfills/array.fill.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/* eslint-disable */
if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, 'fill', {
    value: function (value) {
      // Steps 1-2.
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this); // Steps 3-5.

      var len = O.length >>> 0; // Steps 6-7.

      var start = arguments[1];
      var relativeStart = start >> 0; // Step 8.

      var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.

      var end = arguments[2];
      var relativeEnd = end === undefined ? len : end >> 0; // Step 11.

      var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.

      while (k < final) {
        O[k] = value;
        k++;
      } // Step 13.


      return O;
    }
  });
}
/* eslint-enable */

/***/ }),

/***/ "./src/resources/js/polyfills/array.find-index.js":
/*!********************************************************!*\
  !*** ./src/resources/js/polyfills/array.find-index.js ***!
  \********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/* eslint-disable */
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If IsCallable(predicate) is false, throw a TypeError exception.

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      } // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.


      var thisArg = arguments[1]; // 5. Let k be 0.

      var k = 0; // 6. Repeat, while k < len

      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        } // e. Increase k by 1.


        k++;
      } // 7. Return -1.


      return -1;
    },
    configurable: true,
    writable: true
  });
}
/* eslint-enable */

/***/ }),

/***/ "./src/resources/js/polyfills/array.find.js":
/*!**************************************************!*\
  !*** ./src/resources/js/polyfills/array.find.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/* eslint-disable */
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If IsCallable(predicate) is false, throw a TypeError exception.

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      } // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.


      var thisArg = arguments[1]; // 5. Let k be 0.

      var k = 0; // 6. Repeat, while k < len

      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        } // e. Increase k by 1.


        k++;
      } // 7. Return undefined.


      return undefined;
    },
    configurable: true,
    writable: true
  });
}
/* eslint-enable */

/***/ }),

/***/ "./src/resources/js/polyfills/array.from.js":
/*!**************************************************!*\
  !*** ./src/resources/js/polyfills/array.from.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/* eslint-disable */
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;

    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };

    var toInteger = function (value) {
      var number = Number(value);

      if (isNaN(number)) {
        return 0;
      }

      if (number === 0 || !isFinite(number)) {
        return number;
      }

      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };

    var maxSafeInteger = Math.pow(2, 53) - 1;

    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    }; // The length property of the from method is 1.


    return function from(arrayLike
    /*, mapFn, thisArg */
    ) {
      // 1. Let C be the this value.
      var C = this; // 2. Let items be ToObject(arrayLike).

      var items = Object(arrayLike); // 3. ReturnIfAbrupt(items).

      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      } // 4. If mapfn is undefined, then let mapping be false.


      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;

      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        } // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.


        if (arguments.length > 2) {
          T = arguments[2];
        }
      } // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).


      var len = toLength(items.length); // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).

      var A = isCallable(C) ? Object(new C(len)) : new Array(len); // 16. Let k be 0.

      var k = 0; // 17. Repeat, while k < len… (also steps a - h)

      var kValue;

      while (k < len) {
        kValue = items[k];

        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }

        k += 1;
      } // 18. Let putStatus be Put(A, "length", len, true).


      A.length = len; // 20. Return A.

      return A;
    };
  }();
}
/* eslint-enable */

/***/ }),

/***/ "./src/resources/ts/main.ts":
/*!**********************************!*\
  !*** ./src/resources/ts/main.ts ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(/*! ../js/polyfills/array.fill */ "./src/resources/js/polyfills/array.fill.js");
__webpack_require__(/*! ../js/polyfills/array.find */ "./src/resources/js/polyfills/array.find.js");
__webpack_require__(/*! ../js/polyfills/array.find-index */ "./src/resources/js/polyfills/array.find-index.js");
__webpack_require__(/*! ../js/polyfills/array.from */ "./src/resources/js/polyfills/array.from.js");
var index_esm_1 = __webpack_require__(/*! @biotope/resource-loader/lib/index.esm */ "./node_modules/@biotope/resource-loader/lib/index.esm.js");
var tracking_service_1 = __webpack_require__(/*! ./tracking-service */ "./src/resources/ts/tracking-service.ts");
{
    var handleResourcesReady = function () { return [].slice
        .call(document.querySelectorAll('[data-init]'))
        // eslint-disable-next-line no-eval
        .forEach(function (element) { return eval(element.dataset.init)(element); }); };
    var setupResourceLoader = function () {
        var cssHandler = {
            match: function (options) { return options.resource.path.indexOf('.css') >= 0; },
            handle: function (options) {
                var style = document.createElement('link');
                style.rel = 'stylesheet';
                style.href = options.resource.path;
                document.body.appendChild(style);
            },
        };
        var jsHandler = {
            match: function (options) { return options.resource.path.indexOf('.js') >= 0; },
            handle: function (options) {
                var script = document.createElement('script');
                script.src = options.resource.path;
                script.async = true;
                document.body.appendChild(script);
            },
        };
        return new index_esm_1.default({
            base: biotope.configuration.get('data.staticResourcesBase'),
            baseMap: {
                '##content': biotope.configuration.get('data.staticResourcesContentRepoBase'),
            },
            handler: [cssHandler, jsHandler],
        });
    };
    window.addEventListener('resourcesReady', handleResourcesReady);
    setupResourceLoader();
    svg4everybody();
    // initialize tracking
    tracking_service_1.TrackingService.init();
}
// initialize tracking
window.sss = window.sss || {};
window.sss.datalayer = {
    push: function (event) { return window.dataLayer.push(Array
        .from(event.domEvent.target.attributes)
        .reduce(function (obj, _a) {
        var _b;
        var name = _a.name, nodeValue = _a.nodeValue;
        return (__assign(__assign({}, obj), (name !== 'data-resources' && (_b = {}, _b[name] = nodeValue, _b))));
    }, {
        event: event.eventName,
        type: event.domEvent.type,
        domEvent: event.domEvent,
        context: event.trackingContext,
        data: event.trackingData,
    })); },
};


/***/ }),

/***/ "./src/resources/ts/tracking-service.ts":
/*!**********************************************!*\
  !*** ./src/resources/ts/tracking-service.ts ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var push = function (event) { return window.dataLayer.push(__assign({ event: event.eventName, type: event.domEvent.type, domEvent: event.domEvent, context: event.trackingContext, data: event.trackingData }, Array.from(event.domEvent.target
    ? event.domEvent.target.attributes
    : [])
    .filter(function (_a) {
    var name = _a.name;
    return name !== 'data-resources';
})
    .reduce(function (accumulator, _a) {
    var _b;
    var name = _a.name, nodeValue = _a.nodeValue;
    return (__assign(__assign({}, accumulator), (_b = {}, _b[name] = nodeValue, _b)));
}, []))); };
// eslint-disable-next-line no-prototype-builtins
var isTrackingLoaded = function () { return window.hasOwnProperty('sss')
    // eslint-disable-next-line no-prototype-builtins
    && window.sss.hasOwnProperty('datalayer'); };
var addTrackingObject = function () {
    window.sss = window.sss || {};
    window.sss.datalayer = { push: push };
};
exports.TrackingService = {
    isTrackingLoaded: isTrackingLoaded,
    init: function () {
        if (!isTrackingLoaded()) {
            addTrackingObject();
        }
    },
    send: function (domEvent, eventName, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trackingContext, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trackingData) { return new Promise(function (resolve) {
        window.sss.datalayer.push({
            trackingContext: trackingContext,
            trackingData: trackingData,
            domEvent: domEvent,
            eventName: eventName,
        });
        resolve();
    }); },
};


/***/ })

/******/ });
//# sourceMappingURL=main.js.map
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/set-hash-change-handler.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js":
/*!*****************************************************************!*\
  !*** ./node_modules/smoothscroll-polyfill/dist/smoothscroll.js ***!
  \*****************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict'; // polyfill

  function polyfill() {
    // aliases
    var w = window;
    var d = document; // return if scroll behavior is supported and polyfill is not forced

    if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
      return;
    } // globals


    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468; // object gathering original scroll methods

    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    }; // define timing method

    var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */

    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }
    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */


    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */

    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }
    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */


    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }
    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */


    function shouldBailOut(firstArg) {
      if (firstArg === null || typeof firstArg !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      } // throw error when behavior is not supported


      throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
    }
    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */


    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }
    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */


    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
      return overflowValue === 'auto' || overflowValue === 'scroll';
    }
    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */


    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
      return isScrollableY || isScrollableX;
    }
    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */


    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }
    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */


    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME; // avoid elapsed times higher than one

      elapsed = elapsed > 1 ? 1 : elapsed; // apply easing to elapsed time

      value = ease(elapsed);
      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;
      context.method.call(context.scrollable, currentX, currentY); // scroll more if we have not reached our destination

      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }
    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */


    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now(); // define scroll context

      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      } // scroll looping over a frame


      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    } // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo


    w.scroll = w.scrollTo = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      } // avoid smooth behavior if not required


      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
        arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
        return;
      } // LET THE SMOOTHNESS BEGIN!


      smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
    }; // w.scrollBy


    w.scrollBy = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      } // avoid smooth behavior if not required


      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
        return;
      } // LET THE SMOOTHNESS BEGIN!


      smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
    }; // Element.prototype.scroll and Element.prototype.scrollTo


    Element.prototype.scroll = Element.prototype.scrollTo = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      } // avoid smooth behavior if not required


      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
        arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
        arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top; // LET THE SMOOTHNESS BEGIN!

      smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
    }; // Element.prototype.scrollBy


    Element.prototype.scrollBy = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      } // avoid smooth behavior if not required


      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    }; // Element.prototype.scrollIntoView


    Element.prototype.scrollIntoView = function () {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
        return;
      } // LET THE SMOOTHNESS BEGIN!


      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top); // reveal parent in viewport unless is fixed

        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = {
      polyfill: polyfill
    };
  } else {}
})();

/***/ }),

/***/ "./src/resources/ts/set-hash-change-handler.ts":
/*!*****************************************************!*\
  !*** ./src/resources/ts/set-hash-change-handler.ts ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var smoothscroll = __webpack_require__(/*! smoothscroll-polyfill */ "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
smoothscroll.polyfill();
var headerHeightSmall = 60;
var headerHeightLarge = 80;
var bpLarge = 992;
var scrollAttempts = 0;
var scrollToTarget = function (target) {
    if (!target) {
        return;
    }
    var targetOffsetTop = (target.offsetTop || target.getBoundingClientRect().top)
        + window.pageYOffset;
    if (target) {
        window.scrollTo({
            left: 0,
            top: window.innerHeight < bpLarge
                ? targetOffsetTop - window.pageYOffset - headerHeightSmall - 15
                : targetOffsetTop - window.pageYOffset - headerHeightLarge - 15,
            behavior: 'smooth',
        });
    }
};
var scrollTo = function (hash, withTimeout) {
    var scrollTarget = document.getElementById(hash.replace('+', ''));
    if (withTimeout && !scrollTarget && scrollAttempts < 10) {
        scrollAttempts += 1;
        setTimeout(function () {
            scrollTo(hash, withTimeout);
        }, 1000);
    }
    else {
        scrollToTarget(scrollTarget);
    }
};
var handleHash = function (withTimeout) {
    var urlParts = window.location.href.split('#');
    var hash = urlParts[urlParts.length - 1];
    scrollTo(hash, withTimeout);
};
window.onhashchange = function () { return handleHash(false); };
window.addEventListener('load', function () {
    if (window.location.href.indexOf('#') !== -1) {
        handleHash(true);
    }
});


/***/ })

/******/ });
//# sourceMappingURL=set-hash-change-handler.js.map